import {
  createContext,
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
  useContext,
  useState,
} from 'react';
import dayjs from 'dayjs';

// End of Day Reporting

type EodReportingSession = {
  [reportingDate: string]: {
    [serviceLocationId: string]: {
      paymentMethod: {
        [paymentMethod: string]: {
          actualBalance: number;
          underOverReason?: string | undefined;
        };
      };
      reportSubmitted: boolean;
    };
  };
};

type EodReportingContextProps = {
  reportingDate: dayjs.Dayjs;
  serviceLocationId: string;
  reportingSession: EodReportingSession;
  setReportingDate: Dispatch<SetStateAction<dayjs.Dayjs>>;
  setServiceLocationId: Dispatch<SetStateAction<string>>;
  setReportingSession: Dispatch<SetStateAction<EodReportingSession>>;
};

const EodReportingContext = createContext<EodReportingContextProps>({
  reportingDate: dayjs(),
  serviceLocationId: '',
  reportingSession: {} as EodReportingSession,
  setReportingDate: () => {
    return null;
  },
  setServiceLocationId: () => {
    return null;
  },
  setReportingSession: () => {
    return null;
  },
});

const EodReportingProvider = ({ children }: PropsWithChildren) => {
  const [reportingDate, setReportingDate] = useState(dayjs());
  const [serviceLocationId, setServiceLocationId] = useState('');
  const [reportingSession, setReportingSession] = useState<EodReportingSession>(
    {} as EodReportingSession
  );

  return (
    <EodReportingContext.Provider
      value={{
        reportingDate,
        setReportingDate,
        serviceLocationId,
        setServiceLocationId,
        reportingSession,
        setReportingSession,
      }}
    >
      {children}
    </EodReportingContext.Provider>
  );
};

export const useEodReportingContext = () => useContext(EodReportingContext);

// Store Account Parent (To nest future SA contexts at the top level)
export const StoreAccountingProvider = ({ children }: PropsWithChildren) => {
  return (
    <>
      <EodReportingProvider>{children}</EodReportingProvider>
    </>
  );
};
